import { getItem, removeItem, setItem } from 'utils/sessionStorage'

export const MAX_WAF_CHALLENGE_RELOADS = 5
export const WAF_CHALLENGE_RELOAD_COOLDOWN_MS = 5 * 60 * 1000

const COUNT_KEY = 'wafChallengeReloadCount'
const COOLDOWN_UNTIL_KEY = 'wafChallengeReloadCooldownUntil'

let decisionForThisLoad: boolean | null = null
let hasLoggedLoopThisLoad = false

const computeDecision = (): boolean => {
  const now = Date.now()
  const cooldownUntil = Number(getItem(COOLDOWN_UNTIL_KEY))

  if (cooldownUntil > now) return false

  if (cooldownUntil) {
    removeItem(COOLDOWN_UNTIL_KEY)
    removeItem(COUNT_KEY)
  }

  const count = Number(getItem(COUNT_KEY)) + 1
  setItem(COUNT_KEY, String(count))

  if (count > MAX_WAF_CHALLENGE_RELOADS) {
    setItem(COOLDOWN_UNTIL_KEY, String(now + WAF_CHALLENGE_RELOAD_COOLDOWN_MS))
    return false
  }

  return true
}

// Memoized per load (concurrent 405s from one challenge count as one attempt); persisted via
// sessionStorage so a genuine reload loop across loads still gets capped.
export const shouldReloadOnWafChallenge = (): boolean => {
  if (decisionForThisLoad === null) {
    decisionForThisLoad = computeDecision()
  }

  return decisionForThisLoad
}

// Same concurrency problem as the reload itself: without this, every concurrent 405 during a
// cooldown would log its own Sentry event instead of one per load.
export const shouldLogWafChallengeLoop = (): boolean => {
  if (hasLoggedLoopThisLoad) return false

  hasLoggedLoopThisLoad = true
  return true
}
